<img [src]="imageSrc" class="w-full h-full" [alt]="key" />
